import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const Buttons = props => {
  return (
    <>
      {props.props.relationships.field_button_s &&
        props.props.relationships.field_button_s.map((elem, index) => {
          return (
            <Button
              key={index}
              index={index}
              link={elem.field_link}
              {...props}
            />
          )
        })}
      {props.props.field_link && (
        <Button index={0} link={props.props.field_link} {...props} />
      )}
    </>
  )
}

const Button = props => {
  // console.log(props)

  let title = props.link.title
  let uri = props.link.uri
  let linkInfo = getlinkInfo(uri)

  switch (linkInfo.type) {
    case "internal":
      return (
        <InternalLink
          alias={getAlias(props.data, linkInfo.uri)}
          title={title}
          className={`btn ${
            props.index % 2 === 0 ? "btn-primary" : "btn-secondary"
          }`}
        />
      )
    case "external":
      return (
        <ExternalLink
          alias={getAlias(props.data, linkInfo.uri)}
          title={title}
          className={`btn ${
            props.index % 2 === 0 ? "btn-primary" : "btn-secondary"
          }`}
        />
      )
    default:
      return <span>Unknown link!</span>
  }
}

const getAlias = (data, pid) => {
  let alias = pid
  for (let i in data.allNodePage.edges) {
    if (data.allNodePage.edges[i].node.path.pid.toString() === pid.toString()) {
      alias = data.allNodePage.edges[i].node.path.alias
    }
  }
  return alias
}

const getlinkInfo = uri => {
  let internal1 = uri.split("entity:node/")
  let internal2 = uri.split("internal:")

  if (internal1.length > 1) return { type: "internal", uri: internal1[1] }
  if (internal2.length > 1) return { type: "internal", uri: internal2[1] }
  if (uri.substring(0, 4) === "http") return { type: "external", uri: uri }
  return { type: "unknown", uri: uri }
}

// Create Internal Link - Also handle a hash arg
const InternalLink = props => {
  // console.log(props)

  // const url = typeof window !== 'undefined' ? window.location.pathname : '';
  // console.log(url)

  let to = props.alias

  if (props.alias.substring(0, 1) === "#") {
    return (
      <AnchorLink
        to={
          (typeof window !== "undefined" ? window.location.pathname : "") + to
        }
        title={props.title}
        {...props}
      />
      // <p>Handle #id links</p>
    )
  } else {
    return (
      <Link to={to} {...props}>
        {props.title}
      </Link>
    )
  }
}

// Create External Link
const ExternalLink = props => {
  // console.log(props)

  let to = props.alias

  return (
    <a href={to} {...props} rel="noopener noreferrer" target="_blank">
      {props.title}
    </a>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        allNodePage {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeArticle {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeCaseStudy {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeSolution {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeTechnology {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeTechnologyChild {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
      }
    `}
    render={data => <Buttons data={data} {...props} />}
  />
)
